import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CustomPartDetailsTabContent } from '@/areas/parts/PartDetailsPage/components/CustomPartDetailsTabController';
import { canViewCustomPartOffers } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/parts/custom/$customPartSpecificationId/offers')({
    staticData: { access: { permissions: canViewCustomPartOffers }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { customPartSpecificationId } = Route.useParams();
    return <CustomPartDetailsTabContent tab={'offers'} specificationId={customPartSpecificationId} />;
}
